import { Component, Output, Input, EventEmitter, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderSupervBase } from '@pages/page-superv-base/header-supervbase';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { Listbox, ListboxModule } from "primeng/listbox";
import { DropdownModule } from "primeng/dropdown";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { TooltipModule } from "primeng/tooltip";
import { NgClass} from "@angular/common";
import { TableModule } from 'primeng/table';
import { Visibility } from '@documalis/_const/const';
import { InputTextModule } from 'primeng/inputtext';
import { BskselectComponent } from '@documalis/bskselect/bskselect.component';
import {InputTextareaModule} from "primeng/inputtextarea";

@Component({
    standalone: true,
    selector: 'app-form-supervbase',
    imports: [ReactiveFormsModule,
        ListboxModule,
        TranslateModule,
        TooltipModule,
        NgClass,
        TableModule,
        InputTextModule,
        DropdownModule,
        BskselectComponent, InputTextareaModule
    ],  
    templateUrl: './form-supervbase.component.html',
    styleUrls: ['./form-supervbase.component.scss'],
    providers: [AutofocusDirective],
    encapsulation: ViewEncapsulation.None
})
export class FormSupervBaseComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;
    public listVisibility = [];
    public visibility = 0;

    @Input()
    public dataItem: HeaderSupervBase = null;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public basketList = [];


    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    @ViewChild('bskList') public bskList: Listbox;
    @ViewChild('bskselect') public bskselect: BskselectComponent;
    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            desc: null,
            visibility: [null, [Validators.required]],
            groupListUsed: null,
            userListUsed: null,
            basketListUsed: null
        });
        this.initialization();
    }

    ngOnInit() {
        if (this.dataItem !== null && this.dataItem !== undefined) {
            this.dataItem.notifyParent.subscribe(success => {
                this.resultForm.patchValue(this.dataItem);
                this.bskselect.updateSelectedRows(this.dataItem.basketListUsed);
                this.visibility = this.dataItem.visibility;
            })
        }
    }

    ngOnDestroy() {
        if (this.dataItem !== null && this.dataItem !== undefined) {        
            this.dataItem.notifyParent.unsubscribe();
        }
    }

    public onChangeVisibility($event) {
        this.visibility = $event.value;
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        this.validClick = true;
        const error: Array<Message> = [];
        this.resultForm.controls['basketListUsed'].patchValue(this.bskselect.getBasketList());
        wRequest = {
            data: this.resultForm.value,
        };
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.listVisibility = [];
        this.keys = {
            name: {
                label: this.translate.instant('Superv_Name'),
                pattern: '',
            },
            label: {
                label: this.translate.instant('Superv_Lab'),
                pattern: '',
            },
            visibility: {
                label: this.translate.instant('Visibility'),
                pattern: '',
            },
        };

        Visibility.forEach(item => {
            if (item.id !== 0 && item.id !== 3) {
                this.listVisibility.push({ label: item.name, value: item.id });
            }           
        });  
    }
}
